<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">
      Modulo de prestamos al usuario
    </h2>
    <MainStaffLoans />
  </div>
</template>

<script>
import MainStaffLoans from "@/components/Users/StaffLoans/MainStaffLoans.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "StaffLoans",
  components: {
    MainStaffLoans,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
